import {DefaultResType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {OutgoingCreateType} from "../../pages/inventory/outgoing/create/interface";
import {OutgoingUpdateType} from "../../pages/inventory/inv/history/interface";

const url = "api/inventory/outgoing/";

export async function createOutgoingCode(): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "create_outgoing_code");
    } catch (err: any) {
        return err?.response;
    }
}

export async function createOutgoing(data: OutgoingCreateType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "create_outgoing", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function updateOutgoing(data: OutgoingUpdateType): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "update_outgoing", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function uploadOutgoingExcel(data: FormData): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "upload_outgoing_excel", data, {headers: {"Content-Type": "multipart/form-data"}});
    } catch (err: any) {
        return err?.response;
    }
}

export async function uploadOutgoingBarcode(data: { barcode: string }): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "upload_outgoing_barcode", data);
    } catch (err: any) {
        return err?.response;
    }
}